import { useLocation } from "react-router-dom";

const useQueryParam = (key) => {
  const query = new URLSearchParams(useLocation().search);
  return query.get(key);
};

export default useQueryParam;